<h2 mat-dialog-title class="border-bottom">Dettaglio {{ data.obj.cognome }} {{ data.obj.nome }}</h2>

<mat-dialog-content class="mat-typography p-4">
  <div class="container-fluid">
    <div class="row">
      
      <div class="col-12 mb-4">
        <div class="card border-0 shadow-sm bg-light">
          <div class="card-body">
            <h6 class="text-primary fw-bold mb-3 small">DATI GENERALI</h6>
            <div class="row">
              <div class="col-md-4 mb-2" *ngFor="let entry of anagraficaEntries">
                <small class="text-muted d-block">{{ formatKey(entry[0]) }}</small>
                <span class="fw-bold">{{ entry[1] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header bg-white border-bottom-0 pt-3">
            <h6 class="text-info fw-bold mb-0 small">CONTATTI</h6>
          </div>
          <div class="card-body">
            <div *ngFor="let c of contatti; let last = last" [class.mb-3]="!last" [class.pb-2]="!last" [class.border-bottom]="!last">
              <div class="d-flex align-items-center mb-1">
                <i class="fas fa-phone-alt text-info me-2 small"></i>
                <small class="fw-bold text-uppercase" style="font-size: 0.7rem;">
                  {{ c.tipoContatto?.descrizione }} 
                  <span class="text-muted" *ngIf="c.usoContatto">({{ c.usoContatto.descrizione }})</span>
                </small>
              </div>
              <div class="ps-4 fw-bold text-dark">{{ c.valore }}</div>
            </div>
            <div *ngIf="!contatti.length" class="text-muted small">Nessun contatto presente</div>
          </div>
        </div>
      </div>

      <div class="col-md-6 mb-3">
        <div class="card h-100 border-0 shadow-sm">
          <div class="card-header bg-white border-bottom-0 pt-3">
            <h6 class="text-success fw-bold mb-0 small">INDIRIZZO</h6>
          </div>
          <div class="card-body">
            <div *ngFor="let addr of indirizzi; let last = last" [class.mb-3]="!last">
              <div class="mb-2">
                <span class="badge bg-success-subtle text-success small">
                  {{ addr.usoIndirizzo?.descrizione || 'Indirizzo' }}
                </span>
              </div>
              
              <div class="d-flex align-items-start">
                <i class="fas fa-map-marker-alt text-danger me-2 mt-1"></i>
                <div>
                  <div class="fw-bold">
                    {{ addr.dugDisplay }} {{ addr.streetNameBase }}, {{ addr.houseNumber }}
                  </div>
                  <div class="text-muted small" *ngIf="addr.additionalLocator">
                    ({{ addr.additionalLocator }})
                  </div>
                  <div class="text-dark">
                    {{ addr.cap }} {{ addr.comune?.nome }} ({{ addr.comune?.provinciaSigla }})
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!indirizzi.length" class="text-muted small">Nessun indirizzo presente</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light">
  <button mat-flat-button color="primary" mat-dialog-close>Chiudi</button>
</mat-dialog-actions>